import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function I({ ...rest }) {
	return <FontAwesomeIcon {...rest} />;
}
